import React, { Component } from "react";
import { Row, Col, Form, DatePicker, Input, Button, Modal } from 'antd';
import { UserPhoto } from "./../../common/userPhoto/userPhoto";
import moment from 'moment-timezone';

const FormItem = Form.Item;
const REVIVAL_FINISH_PHASE = 3;

export default class RevivalForm extends Component {
  get preparationDaysCount() {
    const {getFieldValue} = this.props.form;
    return this.periodDaysCount(getFieldValue('preparation_start_date'), getFieldValue('start_date'));
  }

  get revivalDaysCount() {
    const {getFieldValue} = this.props.form;
    return this.periodDaysCount(getFieldValue('start_date'), getFieldValue('end_date'));
  }

  onCancel = () =>{
    Modal.confirm({
      title: "Are you sure you want to leave without saving changes?",
      okText: "Leave",
      width: 600,
      onOk: () => this.props.history.push(`/dashboard/${this.props.church.id}`)
    });
  };

  disabledDate = (current) => {
    return current && current < moment().endOf('day');
  };

  revivalPreparationDisabledDate = (current) => {
    const {getFieldValue} = this.props.form;
    if (current && getFieldValue('start_date')) {
      return !current.isBetween(moment().endOf('day'), getFieldValue('start_date'), null, '[)');
    } else if (current && getFieldValue('end_date')) {
      return !current.isBetween(moment().endOf('day'), getFieldValue('end_date'), null, '[)');
    } else {
      return this.disabledDate(current);
    }
  };

  revivalStartDisabledDate = (current) => {
    const {getFieldValue} = this.props.form;
    if (current && getFieldValue('preparation_start_date') && getFieldValue('end_date')) {
      return !current.isBetween(getFieldValue('preparation_start_date'), getFieldValue('end_date'), null, '[]');
    } else if (current && getFieldValue('end_date')) {
      return !current.isBetween(moment().endOf('day'), getFieldValue('end_date').endOf('day'), null, '[]');
    } else if (current && getFieldValue('preparation_start_date')) {
      return !current.isAfter(getFieldValue('preparation_start_date'), 'day');
    } else {
      return this.disabledDate(current);
    }
  };

  revivalEndDisabledDate = (current) => {
    const {getFieldValue} = this.props.form;
    if (current && getFieldValue('start_date')) {
      return !current.isSameOrAfter(getFieldValue('start_date'), 'day');
    } else if (current && getFieldValue('preparation_start_date')) {
      return !current.isAfter(getFieldValue('preparation_start_date'), 'day');
    } else {
      return this.disabledDate(current);
    }
  };

  periodDaysCount(startDate, endDate) {
    if (startDate && endDate) {
      return endDate.diff(startDate, 'days');
    }
  }

  revivalPhaseCheck(revival, phaseNumber) {
    if (revival) {
      return revival.phase === REVIVAL_FINISH_PHASE ? false : revival.phase > phaseNumber;
    } else {
      return false;
    }
  }

  onPhotoLoad = (photoDataUri) => {
    this.props.form.setFieldsValue({ image_data_uri: photoDataUri });
  };

  resolveValue = (fieldName) => {
    const { revival } = this.props;

    if (!revival) return null;

    if (revival.phase === REVIVAL_FINISH_PHASE) return null;

    return revival[fieldName];
  }

  resolveDateValue = (fieldName) => {
    const { revival, selectedChurch } = this.props;

    if (!revival) return null;

    if (revival.phase === REVIVAL_FINISH_PHASE) return null;

    return moment.unix(revival[fieldName]).tz(selectedChurch.timezone);
  }

  render() {
    const {getFieldDecorator} = this.props.form;
    const {revival} = this.props;

    return (
      <Form onSubmit={this.props.onSubmit} className="login-form">
        <Row className="church-form__revival-schedule">
          <Col xs={{ span: 24 }} md={{ span: 16 }} xl={{ span: 20 }}>
            <Row>
              <FormItem>
                {getFieldDecorator('title', {
                  initialValue: this.resolveValue('title'),
                  rules: [
                    { required: true, message: 'Please input title' }
                  ],
                })(
                  <Input placeholder="Title" />
                )}
              </FormItem>
            </Row>

            <Row>
              <Col span={8}>
                <FormItem label="Event Preparation start">
                  {getFieldDecorator('preparation_start_date', {
                    rules: [
                      { required: true, message: 'Please specify Event preparation start date' }
                    ],
                    initialValue: this.resolveDateValue('preparationStartDate')
                  })(
                    <DatePicker size="small" disabledDate={this.revivalPreparationDisabledDate} disabled={this.revivalPhaseCheck(revival, 0)}/>
                  )}
                </FormItem>
              </Col>
              <Col span={8}>
                <FormItem label="Event start">
                  {getFieldDecorator('start_date', {
                    rules: [
                      { required: true, message: 'Please specify Event start date' }
                    ],
                    initialValue: this.resolveDateValue('startDate')
                  })(
                    <DatePicker size="small" disabledDate={this.revivalStartDisabledDate} disabled={this.revivalPhaseCheck(revival, 0)}/>
                  )}
                </FormItem>
              </Col>
              <Col span={8}>
                <FormItem label="Event finish">
                  {getFieldDecorator('end_date', {
                    rules: [
                      { required: true, message: 'Please specify Event finish date' }
                    ],
                    initialValue: this.resolveDateValue('endDate')
                  })(
                    <DatePicker size="small" disabledDate={this.revivalEndDisabledDate} disabled={this.revivalPhaseCheck(revival, 3)}/>
                  )}
                </FormItem>
              </Col>
            </Row>
          </Col>

          <Col xs={{ span: 24 }} md={{ span: 7, offset: 1 }} xl={{ span: 3, offset: 1 }}>
            <FormItem>
              {getFieldDecorator('image_data_uri', {
                initialValue: '',
                rules: [
                  { required: !revival || revival.phase === REVIVAL_FINISH_PHASE, message: 'Please input event image' }
                ],
              })(
                <UserPhoto photoURL={revival && revival.image && revival.image.default}
                           onPhotoLoad={this.onPhotoLoad}
                           hideRemoveButton/>
              )}
            </FormItem>
          </Col>

          <Col span={24}>
            <p><b>EVENT PREP DAYS: { this.preparationDaysCount || 'XX'}</b> Recomended length of Event Prep phase - no more than 49 days</p>
            <p><b>EVENT DAYS: { this.revivalDaysCount || 'XX'}</b> Recomended length of Event phase - no more than 4 days</p>
          </Col>
        </Row>
        <Row type="flex" justify="end">
          <Col xs={{span: 24}} lg={{offset: 1, span: 10}}>
            <div className="align-right profile-form__form-control">
              <Button onClick={this.onCancel} className="profile-form__inactive-button church-form__control-item">
                Cancel
              </Button>
              <Button type="primary" htmlType="submit" className="profile-form__submit-button church-form__control-item">
                Save Event
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/revivals/revivalForm.js